import React from 'react';

const pillars = [
  { num: '01', title: 'Worship', text: 'Spirit-filled, unrestrained encounter with the living God.' },
  { num: '02', title: 'The Word', text: 'Uncompromising, transformative ministry of the Word.' },
  { num: '03', title: 'Altar Call', text: 'Salvation. Rededication. Holy Spirit infilling.' },
  { num: '04', title: 'Healing', text: 'Come as you are. Leave transformed. God still heals today.' },
  { num: '05', title: 'The Call', text: 'A generation commissioned into the harvest workforce.' },
];

export default function About() {
  return (
    <section id="about" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 80, alignItems: 'center', padding: '120px 64px' }}>
      <style>{`
        @media(max-width:900px){
          #about { grid-template-columns: 1fr !important; gap: 48px !important; padding: 80px 24px !important; }
          .about-pillars { grid-template-columns: 1fr 1fr !important; }
        }
        @media(max-width:480px){
          .about-pillars { grid-template-columns: 1fr !important; }
        }
        .pillar-card { transition: border-color 0.3s, background 0.3s; position: relative; overflow: hidden; }
        .pillar-card::before { content:''; position:absolute; top:0; left:0; width:3px; height:0; background:var(--ember); transition:height 0.4s ease; }
        .pillar-card:hover::before { height:100%; }
        .pillar-card:hover { border-color: rgba(200,68,10,0.4) !important; background: rgba(200,68,10,0.08) !important; }
        .reveal { opacity:0; transform:translateY(40px); transition:opacity 0.7s ease, transform 0.7s ease; }
        .reveal.visible { opacity:1; transform:translateY(0); }
        .reveal-d1 { transition-delay:0.1s; }
        .reveal-d2 { transition-delay:0.2s; }
        .reveal-d3 { transition-delay:0.3s; }
        .reveal-d4 { transition-delay:0.4s; }
      `}</style>

      <div>
        <p className="reveal" style={{ fontSize: 10, letterSpacing: '0.35em', textTransform: 'uppercase', color: 'var(--ember)', marginBottom: 20 }}>What Is REVIVE</p>
        <h2 className="reveal" style={{ fontFamily: 'var(--font-display)', fontSize: 'clamp(48px,6vw,80px)', lineHeight: 0.95, letterSpacing: '0.02em', color: 'var(--white)', marginBottom: 24 }}>
          NOT A<br />CONFERENCE.<br />A MOVEMENT.
        </h2>
        <div className="reveal" style={{ width: 48, height: 3, background: 'linear-gradient(90deg,var(--ember),var(--gold))', margin: '0 0 32px' }} />
        <p className="reveal reveal-d1" style={{ fontFamily: 'var(--font-serif)', fontSize: 'clamp(16px,1.4vw,19px)', lineHeight: 1.8, color: 'rgba(245,240,232,0.6)', maxWidth: 520 }}>
          REVIVE is a one-night awakening rally sweeping across eight cities. Worship. The Word. An altar call that changes lives. A call to the workforce — because the harvest is plentiful and the laborers are few.
        </p>
        <p className="reveal reveal-d2" style={{ fontFamily: 'var(--font-serif)', fontSize: 'clamp(16px,1.4vw,19px)', lineHeight: 1.8, color: 'rgba(245,240,232,0.6)', maxWidth: 520, marginTop: 20 }}>
          We are not coming to your city for an event. We are coming to ignite a fire that will not go out when the night ends.
        </p>

        <div className="about-pillars reveal reveal-d2" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20, marginTop: 48 }}>
          {pillars.map((p, i) => (
            <div key={p.num} className={`pillar-card reveal reveal-d${Math.min(i + 1, 4)}`}
              style={{ padding: '24px', border: '1px solid rgba(200,68,10,0.12)', background: 'rgba(200,68,10,0.03)' }}>
              <div style={{ fontFamily: 'var(--font-display)', fontSize: 40, color: 'rgba(200,68,10,0.18)', lineHeight: 1, marginBottom: 6 }}>{p.num}</div>
              <div style={{ fontFamily: 'var(--font-body)', fontSize: 10, fontWeight: 500, letterSpacing: '0.2em', textTransform: 'uppercase', color: 'var(--gold)', marginBottom: 8 }}>{p.title}</div>
              <div style={{ fontSize: 13, color: 'rgba(245,240,232,0.5)', lineHeight: 1.6 }}>{p.text}</div>
            </div>
          ))}
        </div>
      </div>

      <div className="reveal reveal-d2">
        <blockquote style={{ fontFamily: 'var(--font-serif)', fontStyle: 'italic', fontSize: 'clamp(22px,3vw,40px)', lineHeight: 1.35, color: 'var(--white)', borderLeft: '3px solid var(--ember)', paddingLeft: 32, marginBottom: 48 }}>
          "One night with God will change the trajectory of an entire generation."
        </blockquote>
        <div style={{ padding: '36px', border: '1px solid rgba(212,168,67,0.15)', background: 'rgba(212,168,67,0.04)' }}>
          <p style={{ fontFamily: 'var(--font-body)', fontSize: 10, letterSpacing: '0.25em', textTransform: 'uppercase', color: 'var(--gold)', marginBottom: 16 }}>The Mandate</p>
          <p style={{ fontFamily: 'var(--font-serif)', fontSize: 17, lineHeight: 1.8, color: 'rgba(245,240,232,0.55)' }}>
            Every REVIVE event ends with a public, visible workforce call. People are not just moved — they are <em>mobilized</em>. Your city will not be the same.
          </p>
        </div>
      </div>
    </section>
  );
}
